const styles = theme => ({
    container:{
        backgroundColor: '#f5f5f5'
    },
    title:{
        fontFamily: 'AvenirNext-DemiBold',
        fontSize: '12px',
        fontWeight: 600,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#4d4d4d',
        width: '190px',
        height: '16px',
        margin: '18px 0px 3px'
    },
    description:{
        fontFamily: 'AvenirNext',
        fontSize: '12px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#565656',
        width: '266px',
        height: '32px',
        margin: '0 0 10px'
    }

});

export default styles;


